// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2JQWf","filesListContainer":"PosDisputesFiles_filesListContainer__Z6bbm","filesButton":"PosDisputesFiles_filesButton__2DsGz"};